"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var hubspot_svg_1 = __importDefault(require("@ClientAssets/icons/features/hubspot.svg"));
var google_logo_light_svg_1 = __importDefault(require("@ClientAssets/icons/google-logo-light.svg"));
var salesforce_svg_1 = __importDefault(require("@ClientAssets/icons/features/salesforce.svg"));
var microsoft_logo_light_svg_1 = __importDefault(require("@ClientAssets/icons/microsoft-logo-light.svg"));
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var Masthead_1 = __importDefault(require("../Masthead/Masthead"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var GatekeeperTelemetry_1 = require("Gatekeeper/GatekeeperTelemetry");
var inversify_react_1 = require("inversify-react");
var Navigation_1 = require("Gatekeeper/Navigation/Navigation");
var ExtractQueryParam_1 = __importDefault(require("Gatekeeper/ExtractQueryParam"));
var Common_1 = require("Gatekeeper/Common");
var styles = __importStar(require("./Login.css"));
var Login = (function (_super) {
    __extends(Login, _super);
    function Login(props) {
        var _this = _super.call(this, props) || this;
        _this.showSSO = true;
        if (window.localStorage) {
            _this.showSSO = localStorage.getItem("hideSSO") !== "true";
            localStorage.setItem("hideSSO", "".concat(!_this.showSSO));
        }
        return _this;
    }
    Login.prototype.componentDidMount = function () {
        var wasFromSignup = (0, ExtractQueryParam_1.default)(window.location, Navigation_1.GATEKEEPER_SIGNUP_QS_KEY);
        if (wasFromSignup) {
            this.gatekeeperTelemetry.track("Signup Page Login Clicked");
            var withTemplate = (0, ExtractQueryParam_1.default)(window.location, "with_template");
            if (withTemplate) {
                sessionStorage.setItem("url", "/#/sample-page-creator/template/".concat(withTemplate));
            }
            var withPage = (0, ExtractQueryParam_1.default)(window.location, "with_page");
            if (withPage) {
                sessionStorage.setItem("url", "/#/sample-page-creator/page_builder_ai/".concat(withPage));
            }
        }
    };
    Login.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(Masthead_1.default, { explainer: "Welcome back", back: this.showSSO ? undefined : function () { return _this.setShowSSO(true); } }, this.showSSO ? this.ssoPage : this.formPage));
    };
    Object.defineProperty(Login.prototype, "formPage", {
        get: function () {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(kaleidoscope_1.FormComponent, { fieldSize: "large", onSubmit: this.onComplete },
                    react_1.default.createElement(kaleidoscope_1.FormContext.Consumer, null, function (_a) {
                        var submitError = _a.submitError;
                        return (react_1.default.createElement(kaleidoscope_1.Stack, { padding: "l", gap: "l", className: styles.formContainer },
                            react_1.default.createElement(kaleidoscope_1.FormTextInput, { id: "login-email", type: kaleidoscope_1.TextInputType.Email, name: "email", label: "Work Email", placeholder: "jackie@riley.com", validate: function (value) {
                                    if (value.length === 0) {
                                        return "Please provide your email";
                                    }
                                } }),
                            react_1.default.createElement(kaleidoscope_1.FormTextInput, { id: "login-password", type: kaleidoscope_1.TextInputType.Password, name: "password", label: "Password", placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022", validate: function (value) {
                                    if (value.length === 0) {
                                        return "Please provide a password";
                                    }
                                } }),
                            submitError && (react_1.default.createElement(kaleidoscope_1.Expandable, { expanded: !!submitError, timeout: kaleidoscope_1.AnimationDuration.Short, "aria-live": "polite" }, function (_a) {
                                var expandableElementRef = _a.expandableElementRef;
                                return (react_1.default.createElement("div", { ref: expandableElementRef },
                                    react_1.default.createElement(kaleidoscope_1.Alert, { heading: "Error", alertType: kaleidoscope_1.AlertType.Error, "aria-live": "polite" }, submitError)));
                            })),
                            react_1.default.createElement(kaleidoscope_1.Stack, { justify: "center", paddingTop: "m", direction: "horizontal" },
                                react_1.default.createElement(kaleidoscope_1.FormSubmitButton, { id: "loginbutton", width: "half", "data-synthetics-selector": "form-button" }, "Log in"))));
                    })),
                react_1.default.createElement("div", { className: "masthead__alt" },
                    react_1.default.createElement(kaleidoscope_1.Link, { href: "/#/login/reset-password" }, "Forgot password?"))));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Login.prototype, "ssoPage", {
        get: function () {
            var _this = this;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "masthead__sso" },
                    react_1.default.createElement(kaleidoscope_1.Button, { className: "button__google", openInSameTab: true, href: function () {
                            return (0, Common_1.buildSSOUrl)({
                                baseUrl: _this.props.publicApiBaseUrl,
                                authRoute: "/auth/google?action=login",
                            });
                        } },
                        react_1.default.createElement(kaleidoscope_2.SVG, { className: "large", src: google_logo_light_svg_1.default }),
                        "Continue with Google"),
                    react_1.default.createElement(kaleidoscope_1.Button, { className: "button__salesforce", openInSameTab: true, href: function () { return "".concat(_this.props.publicApiBaseUrl, "/auth/salesforce?sso=true&action=login"); } },
                        react_1.default.createElement(kaleidoscope_2.SVG, { className: "large", src: salesforce_svg_1.default }),
                        "Continue with Salesforce"),
                    react_1.default.createElement(kaleidoscope_1.Button, { className: "button__hubspot", openInSameTab: true, href: function () {
                            return (0, Common_1.buildSSOUrl)({
                                baseUrl: _this.props.publicApiBaseUrl,
                                authRoute: "/auth/hubspot?sso=true&action=login",
                            });
                        } },
                        react_1.default.createElement(kaleidoscope_2.SVG, { className: "large", src: hubspot_svg_1.default }),
                        "Continue with HubSpot"),
                    react_1.default.createElement(kaleidoscope_1.Button, { className: "button__microsoft", openInSameTab: true, href: function () {
                            return (0, Common_1.buildSSOUrl)({
                                baseUrl: _this.props.publicApiBaseUrl,
                                authRoute: "/auth/microsoft?action=login",
                            });
                        } },
                        react_1.default.createElement(kaleidoscope_2.SVG, { className: "large", src: microsoft_logo_light_svg_1.default }),
                        "Continue with Microsoft")),
                react_1.default.createElement("div", { className: "masthead__alt" },
                    "Or",
                    " ",
                    react_1.default.createElement(kaleidoscope_1.Link, { id: "continue-with-email-link", onClick: function () { return _this.setShowSSO(false); } }, "continue with email"))));
        },
        enumerable: false,
        configurable: true
    });
    Login.prototype.onComplete = function (values) {
        return __awaiter(this, void 0, Promise, function () {
            var email, password, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        email = values.email, password = values.password;
                        if (!(typeof email === "string" && typeof password === "string")) return [3, 2];
                        return [4, this.props.onComplete({
                                username: email,
                                password: password,
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [3, 4];
                    case 3:
                        e_1 = _a.sent();
                        return [2, (0, kaleidoscope_1.createFormSubmitErrorObject)(e_1.message || "Please check your credentials and try again.")];
                    case 4: return [2];
                }
            });
        });
    };
    Login.prototype.setShowSSO = function (showSSO) {
        this.showSSO = showSSO;
        if (window.localStorage) {
            localStorage.setItem("hideSSO", "".concat(!this.showSSO));
        }
    };
    var _a, _b, _c;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], Login.prototype, "showSSO", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_a = typeof GatekeeperTelemetry_1.GatekeeperTelemetry !== "undefined" && GatekeeperTelemetry_1.GatekeeperTelemetry) === "function" ? _a : Object)
    ], Login.prototype, "gatekeeperTelemetry", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Login.prototype, "formPage", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Login.prototype, "ssoPage", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof kaleidoscope_1.FormValues !== "undefined" && kaleidoscope_1.FormValues) === "function" ? _b : Object]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], Login.prototype, "onComplete", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], Login.prototype, "setShowSSO", null);
    Login = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], Login);
    return Login;
}(react_1.default.Component));
exports.default = Login;
